<script>
export default {
  name: 'BaseCenter',
  functional: true,
  props: {
    span: {
      type: Number,
      default: 24,
    },
    xs: {
      type: Number,
    },
    sm: {
      type: Number,
    },
    md: {
      type: Number,
    },
    lg: {
      type: Number,
    },
    xl: {
      type: Number,
    },
    center: {
      type: Boolean,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  render(h, ctx) {
    const slots = ctx.slots().default;
    if (!slots) {
      return null;
    }

    const data = {};

    if (ctx.props.center) {
      data.class = {
        'is-text-center': true,
      };
    }

    if (ctx.props.fullHeight) {
      data.class = {
        'el-full-height': true,
      };
    }

    data.props = {};

    const dimensions = ['span', 'xs', 'sm', 'md', 'lg', 'xl'];

    dimensions.forEach((d) => {
      if (ctx.props[d]) {
        let span = ctx.props[d];
        let offset = 24 - span;
        if (offset > 0) {
          if (offset % 2 > 0) {
            offset += 1;
            span -= 1;
          }
          offset /= 2;
        }

        if (d === 'span') {
          data.props[d] = span;
          if (offset > 0) {
            data.props.offset = offset;
          }
        } else {
          const p = { span };
          if (offset > 0) {
            p.offset = offset;
          }
          data.props[d] = p;
        }
      }
    });

    return (
      <el-row
        type="flex"
        align="middle"
        class="el-row--fullscreen">
        { h('el-col', data, slots) }
      </el-row>
    );
  },
};
</script>
